import type { Judgement } from './types';

/**
 * 【デザイン比較用】判定 Select のドットインジケータ色（Google Chat ステータス風）。
 *
 * トリガー全体を塗りつぶす代わりに、ラベル先頭に小さな色付きドットを表示する案。
 * - matched（該当）    → 緑の塗りつぶしドット
 * - not-matched（非該当）→ 暗グレーの塗りつぶしドット
 * - pending（未判定）  → アウトラインのみ（中空）の円
 */
export const JUDGEMENT_DOT_STYLES: Record<Judgement, string> = {
  pending: 'border border-text-secondary bg-transparent',
  matched: 'bg-green-600 border border-green-600',
  'not-matched': 'bg-stone-500 border border-stone-500',
};
